import { NumberFormat, Space } from '@billy/design-system'
import { Fragment, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicePayloadTaxSummary } from '@features/invoices/types/invoicePayload/invoicePayloadSummary'
import { useGetRegionFromContactCountryCode } from '@features/vatRates/hooks/useGetRegionFromContactCountryCode'

import { LocaleIdentifier } from '../../../../../../../../../../../../types/localeIdentifier'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'
import { InvoiceSummaryLine } from '../InvoiceSummaryLine'

interface InvoiceSummaryTaxesProps {
  currency: string
  locale: LocaleIdentifier
  taxSummary: InvoicePayloadTaxSummary[]
}

export const InvoiceSummaryTaxes = ({ currency, locale, taxSummary }: InvoiceSummaryTaxesProps) => {
  const { t } = useTranslation()
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { getRegionFromContactCountryCode } = useGetRegionFromContactCountryCode()

  const contactCountryCode = invoiceEditorForm.watch('receiver.countryId')

  const region = useMemo(
    () => getRegionFromContactCountryCode(contactCountryCode),
    [contactCountryCode, getRegionFromContactCountryCode],
  )

  return taxSummary.map(({ amount, percentage }, index) => {
    const formattedPercentage = NumberFormat.getPercentNumber(percentage, locale)
    const isZeroVatRate = percentage === 0

    return (
      <Fragment key={`${amount}-${percentage}-${index}`}>
        <InvoiceSummaryLine
          label={t('external_invoices.editor.summary.vat', { percentage: formattedPercentage })}
          text={NumberFormat.getCurrencyNumber(amount, currency, locale)}
          region={isZeroVatRate ? region : undefined}
        />
        <Space size="s8" />
      </Fragment>
    )
  })
}
